import React, { Fragment, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import styled from '@emotion/styled';
import moment from 'moment';
import 'moment/locale/ru';
import { useSelector } from 'react-redux';

import SupplyStatus from '../SupplyStatus';
import StatusBadge from '../../common/StatusBadge';
import { useAutoTranslation } from '../../../helpers/useAutoTranslation';

import 'moment/locale/zh-cn';
import 'moment/locale/ru';
moment.locale('zh-cn');
moment.locale('ru');

const Wrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  .fe-arrow-left {
    color: #323a46;
    margin-right: 10px;
  }

  .supply-id-edit {
    margin-left: 16px;
    cursor: pointer;
  }
`;

const DesktopHeader = (props) => {
  const currentSupply = useSelector((state) => state.supplies.currentSupply);
  const { supplyCustomId, setSupplyCustomId } = props;

  const { t, i18n } = useAutoTranslation();
  const localeCode = i18n.language === 'cn' ? 'zh-cn' : 'ru';

  //Если id поставки пустой - это новая поставка
  const pageTitle = currentSupply ? currentSupply.id || t('Новая поставка') : '';

  const [showIdEdit, setShowIdEdit] = useState(false);

  useEffect(() => {
    if (pageTitle) {
      document.title = pageTitle + ` — ${t('Кактус')}`;
    }
  }, [pageTitle]);

  if (!currentSupply) {
    return null;
  }

  const checkRelatedOrders = (items) => {
    return items?.find((item) => item.orderDocId);
  };

  return (
    <Wrapper className="page-title-box">
      <h4 className="page-title d-flex align-items-center">
        <Link to={'/supplies'}>
          <i className="fe-arrow-left" />
        </Link>
        {pageTitle}
        {!currentSupply.id ? (
          <>
            {!showIdEdit ? (
              <div className="supply-id-edit">
                <i className="fe-edit" onClick={() => setShowIdEdit(true)}></i>
              </div>
            ) : (
              <div className="supply-id-edit-input ml-3">
                <input
                  type="text"
                  className="form-control"
                  id="id"
                  placeholder="№"
                  value={supplyCustomId}
                  onChange={(e) => setSupplyCustomId(e.target.value)}
                />
              </div>
            )}
          </>
        ) : null}
      </h4>

      {currentSupply.id ? (
        <Fragment>
          <i className="fe-calendar ml-3 mr-1" />
          <span className="mr-3">
            {moment(currentSupply.date).locale(localeCode).format('DD MMM YYYY HH:mm:SS')}
          </span>
          <SupplyStatus
            status={currentSupply.status}
            checkRelatedOrders={checkRelatedOrders(currentSupply.planItems)}
          />
        </Fragment>
      ) : null}
    </Wrapper>
  );
};

export default DesktopHeader;
